export default __webpack_public_path__ + "static/media/style_null.3b3d9bf5.svg";